import axios from "axios";
import instance from "../../axios";

export const API_URL = `${process.env.REACT_APP_API_URL}`;
export const BASE_URL_LIVE = `${process.env.REACT_APP_API_URL_LIVE}`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
export const DASHBOARD_URL = `${process.env.REACT_APP_API_URL}/dashboards`;
export const s3_base_url = `${process.env.REACT_APP_UPLOADED_FILE_URL}`;

export const getCountryList = () => {
  return instance.post(`${API_URL}/country/list`)
    .then(res => {
      return res;
    })
};

export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/company/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}

export const getSearchList = (queryParams) => {
  return instance.post(`${API_URL}/${queryParams.source}/search`, queryParams.filter)
    .then(res => {
      return res;
    })
};

export function getGameList(queryParams) {
  return axios.post(`${API_URL}/${queryParams.source}/list`, queryParams.filter);
};

export function getAllGamesList(queryParams) {
  console.log('queryParams WEWEWE:', queryParams)
  return instance.post(`${BASE_URL}/game/list`, queryParams)
    .then(res => {
      return res;
    })
};

export function getLevelsSearchList(queryParams) {
  return instance.post(`${BASE_URL}/levels/search`, queryParams)
    .then(res => {
      return res;
    })
};
